import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideLogRocket } from '@core/observability/logrocket/logrocket.providers';
import { provideNewRelic } from '@core/observability/newrelic/newrelic.providers';

export function provideObservability(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideNewRelic(),
    provideLogRocket()
  ])
}
